import React, { useEffect } from "react";
import styles from "../../../styles/component-styles/general/input.module.scss";
import search_ic from "../../../assets/icons/search.svg";
import { PrimaryButton } from "./primary-button";
import close_ic from "../../../assets/icons/close.svg";
import { useSelector } from "react-redux";
import { selectLanguage } from "../../../redux/slice/language/laguage.slice";
import { constants } from "../../../constants";
import { Button } from "../button/Button";
export function SearchBox({ placeholder, value, onSearch, onClear }) {
  const [inputValue, setInputValue] = React.useState(value);
  const [isClicked, setIsClicked] = React.useState(value?.length > 0);
  const language = useSelector(selectLanguage);
  const onChange = (e) => {
    setInputValue(e.target.value);
  };

  return (
    <div className={styles.searchBox}>
      <img src={search_ic} alt="search" className={styles.icon} />
      <input
        type="text"
        placeholder={placeholder}
        value={inputValue}
        className={styles.textBox}
        onChange={onChange}
        onKeyDown={(e) => {
          if (e.key === "Enter" && inputValue?.trim()?.length > 0) {
            onSearch(inputValue);
            setIsClicked(true);
          }
        }}
      />
      {isClicked ? (
        <button
          className={styles.clearBtn}
          onClick={() => {
            setInputValue("");
            setIsClicked(false);
            onClear();
          }}
        >
          <img src={close_ic} />
          {constants[language].clear}
        </button>
      ) : (
        <>
          <Button
            style={{ width: "100px" }}
            onClick={() => {
              if (inputValue?.trim()?.length > 0) {
                setIsClicked(true);
                onSearch(inputValue.trim());
              }
            }}
          >
            {constants[language].search}
          </Button>
          {/* no need to define the button two times sepratly for mobile and large screen */}
          {/* <span className={styles.mobileSearchBtn}>
            <PrimaryButton
              style={{ width: "70px", fontSize: "12px", height: "30px" }}
              onClick={() => {
                setIsClicked(true);
                onSearch(value);
              }}
            >
              {constants[language].search}
            </PrimaryButton>
          </span>
          <span className={styles.searchBtn}>
            <PrimaryButton
              style={{ width: "100px" }}
              onClick={() => {
                setIsClicked(true);
                onSearch(value);
              }}
            >
              {constants[language].search}
            </PrimaryButton>
          </span> */}
        </>
      )}
    </div>
  );
}
